import SupportV2FormPage from 'pages/support-v2/support-v2-form-page';

export default function SupportFormPage() {
  return <SupportV2FormPage />;
}
